import {useContext} from "react";
import {StoreContext} from "../stores/StoreLoader";
import {values} from "mobx";

export function useHeroTerrace(): IHeroTerraceBlock {
    const {gridStore} = useContext(StoreContext);
    return values(gridStore.blocks).find(b => b.type === "hero");
}